<template>
  <el-dialog v-loading="loading" :visible.sync="dialogVisible" :title="title" :width="width" class="vdd-dialog-host"
    custom-class="vdd-dialog" :append-to-body="appendToBody" :close-on-click-modal="false"
    :close-on-press-escape="false" :before-close="handleBeforeClose" v-bind="$attrs" v-on="$listeners">
    <div class="visit-detail-panel">
      <div class="visit-overview">
        <div class="visit-patient">
          <strong>{{ patientName }}</strong>
          <span>{{ patientSexText }} / {{ patientAgeText }}</span>
        </div>
        <el-tag class="visit-status" size="mini">{{ statusInfo.name }}</el-tag>
        <div class="visit-meta">
          <span v-for="item in overviewList" :key="item.label">
            <label>{{ item.label }}</label>{{ item.value }}
          </span>
        </div>
      </div>

      <section class="visit-section">
        <div class="visit-section-title"><i />病历 （{{orderInfo.orderId}}）</div>
        <div class="medical-record">
          <p v-for="item in medicalRecordItems" :key="item.field">
            <label>{{ item.label }}</label>
            <span v-if="item.html" v-html="item.value"></span>
            <span v-else>{{ item.value }}</span>
          </p>
          <p v-if="caseImageList.length">
            <label>附件</label>
            <span class="vdd-case-images">
              <el-image v-for="(url, imgIndex) in caseImageList" :key="url || imgIndex" class="vdd-case-image"
                :src="url" :preview-src-list="caseImageList" />
            </span>
          </p>
        </div>
      </section>

      <section class="visit-section">
        <div class="visit-section-title"><i />处方项目</div>
        <div v-if="normalizedPrescriptionSections.length || normalizedActivitySections.length" class="prescription-list">
          <div v-for="(section, sectionIndex) in normalizedPrescriptionSections" :key="section.id || sectionIndex">
            <div v-if="section.kind === 'physio'" class="physio-warp visit-physio-prescription backfff">
              <div class="physio-top">
                <div class="top-left">
                  <img :src="section.iconSrc" class="physio-icon">
                  <div class="physio-title">{{ section.title }}</div>
                  <div>{{ section.totalText }}</div>
                </div>
                <div>
                  <span>{{ section.uniOrderNumber || '' }}</span>
                  <el-button v-if="canPrintSinglePrescription(section)" size="mini" class="vdd-single-print-btn"
                  @click.stop="printSinglePrescription(section)">打印</el-button>
                </div>
              </div>
              <div class="physio-content backfff">
                <div v-for="(contentItem, physioIndex) in section.items" :key="contentItem.key || physioIndex">
                  <div class="add-warp">
                    <div class="index">
                      <span>{{ physioIndex + 1 }}</span>
                    </div>
                    <div class="select-warp readonly-select-warp">
                      <span class="readonly-name">{{ contentItem.raw.itemName || contentItem.raw.physioName ||
                        contentItem.label || '-' }}</span>
                    </div>
                    <div class="add-right">
                      <div class="unit-warp">单位：{{ contentItem.raw.itemUnit || contentItem.raw.unit || '-' }}</div>
                      <div class="price-warp">
                        <div>￥{{ formatNumber(contentItem.raw.price) }}/{{ displayPhysioUnitLabel(contentItem.raw) }}
                        </div>
                      </div>
                      <div class="edit-warp">
                        <div class="ml5 item-section">￥</div>
                        <div>{{ displayPhysioUnitAmount(contentItem.raw) }}</div>
                        <div class="ml5 item-section">
                          <div>每 次</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="acupoint-warp" v-if="hasAcupointList(contentItem.raw)">
                    <div class="acupoint-list">
                      <div class="acupoint-item" v-for="(acupoint, acupointIndex) in getAcupointList(contentItem.raw)"
                        :key="acupoint.acupointId || acupointIndex">
                        <div class="acupoint-item-left">{{ acupointLabel(acupoint) }}</div>
                        <div class="acupoint-item-name">{{ acupoint.acupointName || '-' }}</div>
                      </div>
                    </div>
                    <div class="acupoint-total">{{ acupointTotalText(contentItem.raw) }}</div>
                  </div>
                  <div class="other-warp" v-if="hasPhysioMeta(contentItem.raw)">
                    <div class="other-warp-left">
                      <div class="other-num-input">
                        <div class="num-input">{{ displayPhysioSoldNum(contentItem.raw) }}</div>
                        <div>次</div>
                      </div>
                      <div class="other-num-input" v-if="isGroupedPhysio(contentItem.raw)">
                        <div class="flex-sh">1次</div>
                        <div class="onlyNum-input">{{ displayPhysioOnlyNum(contentItem.raw) }}</div>
                        <div>组</div>
                      </div>
                      <div class="frequency-input">
                        <div class="frequency-text">{{ displayPhysioFrequency(contentItem.raw) }}</div>
                      </div>
                      <div class="other-desc"
                        v-if="isGroupedPhysio(contentItem.raw) && physioPerUnitCount(contentItem.raw)">
                        每组{{ physioPerUnitCount(contentItem.raw) }}个{{ physioPerUnitName(contentItem.raw) }}，每次至少选择{{
                          displayPhysioMinCount(contentItem.raw) }}个{{ physioPerUnitName(contentItem.raw) }}
                      </div>
                      <div class="other-desc" v-else-if="physioPerUnitCount(contentItem.raw)">
                        每次至少选择{{ physioPerUnitCount(contentItem.raw) }}个{{ physioPerUnitName(contentItem.raw) }}
                      </div>
                      <div class="other-tips" v-if="computedShowTips(contentItem.raw)">
                        <span class="iconfont icon-jingg colorFE8F mr6"></span>选{{
                          physioOtherPerUnitName(contentItem.raw) }}不计入已选数量
                      </div>
                    </div>
                    <div class="other-warp-right">￥{{ displayPhysioTotal(contentItem.raw) }}</div>
                  </div>
                  <div class="other-warp" v-if="contentItem.raw.remark">
                    <div class="physio_remark_row">
                      <div class="physio_remark_label">理疗备注:</div>
                      <div class="physio_product_remark readonly">{{ contentItem.raw.remark }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="section.kind === 'chinese'" class="physio-warp visit-chinese-prescription backfff">
              <div class="physio-top backfff">
                <div class="top-left">
                  <img :src="section.iconSrc" class="physio-icon">
                  <div class="physio-title">{{ section.title }}</div>
                  <div>{{ section.totalText }}</div>
                </div>
                <el-button v-if="canPrintSinglePrescription(section)" size="mini" class="vdd-single-print-btn"
                  @click.stop="printSinglePrescription(section)">打印</el-button>
              </div>
              <div class="physio-content backfff">
                <div class="add-warp" v-for="(item, index) in section.items" :key="item.key || index">
                  <div class="add-warp-item">
                    <div class="index">
                      <span>{{ index + 1 }}</span>
                    </div>
                    <div class="select-warp readonly-select-warp">
                      <span class="readonly-name">{{ item.raw.itemName || item.raw.drugName || item.label || '-'
                        }}</span>
                    </div>
                    <div class="add-right">
                      <div class="edit-warp">
                        <span class="ml5">￥</span>
                        <span>{{ formatNumber(item.raw.price) }}</span>
                      </div>
                      <div class="edit-warp" style="text-align: center; width: 30px">
                        <div class="w100_">x</div>
                      </div>
                      <div class="edit-warp" style="width: 50px">
                        <div class="w100_">{{ item.raw.itemNum || item.raw.num || item.raw.quantity || 1 }}</div>
                      </div>
                      <div class="edit-warp" style="text-align: center; width: 30px">
                        <div class="w100_">{{ item.raw.itemUnit || item.raw.unit || '-' }}</div>
                      </div>
                      <div class="edit-warp">
                        <span class="ml5">￥</span>
                        {{ displayChineseTotal(item.raw) }}
                      </div>
                      <div class="edit-warp">
                        <el-input class="readonly-remark" v-model="item.raw.remark" disabled />
                      </div>
                    </div>
                  </div>
                  <div class="add-warp-bottom" v-if="item.label">
                    <div class="method-warp">
                      <div class="method-item">{{ displayDictValue(item.raw.useFrequency, dictData.useFrequency) }}
                      </div>
                      <div class="singleDose-warp">
                        <div class="pb3 flex-sh">1次</div>
                        <div class="singleDose-input">{{ item.raw.singleDose || '-' }}</div>
                        <div>{{ displayDictValue(item.raw.singleDoseUnit, dictData.singleDoseUnit) }}</div>
                      </div>
                      <div class="method-item">{{ displayDictValue(item.raw.takingTime, dictData.takingTime) }}</div>
                      <div class="method-item">{{ displayDictValue(item.raw.intervalRequirement,
                        dictData.intervalRequirement) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="section.kind === 'other'" class="vdd-other-prescription backfff">
              <div class="vdd-other-top backfff">
                <div class="vdd-other-title">{{ section.title }}</div>
                <div class="vdd-other-total">{{ section.totalText }}</div>
              </div>
              <div class="vdd-other-content">
                <div class="vdd-other-row" v-for="(item, index) in section.items" :key="item.key || index">
                  <div class="vdd-other-index">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <div class="vdd-other-select">
                    <div class="vdd-other-name">{{ displayOtherName(item.raw, item.label) }}</div>
                  </div>
                  <div class="vdd-other-right">
                    <div class="vdd-other-edit">
                      <span class="ml5">￥</span>
                      <span>{{ formatNumber(item.raw.price) }}</span>
                    </div>
                    <div class="vdd-other-edit vdd-other-symbol">
                      <div class="w100_">x</div>
                    </div>
                    <div class="vdd-other-edit vdd-other-num">
                      <div class="w100_">{{ item.raw.itemNum || item.raw.num || item.raw.quantity || 1 }}</div>
                    </div>
                    <div class="vdd-other-edit vdd-other-unit">
                      <div class="w100_">{{ item.raw.itemUnit || item.raw.unit || '-' }}</div>
                    </div>
                    <div class="vdd-other-edit">
                      <span class="ml5">￥</span>
                      {{ displayOtherTotal(item.raw) }}
                    </div>
                    <div class="vdd-other-edit">
                      <div class="vdd-other-remark">{{ item.raw.remark || '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="drug-warp backfff" :class="section.cardClass">
              <div class="drug-top">
                <div class="top-left">
                  <div class="drug-index">
                    <img :src="section.iconSrc" class="drug-icon" />
                    <div class="font600 size14 color6671">{{ section.title }}</div>
                  </div>
                  <div class="drug-total">{{ section.totalText }}</div>
                </div>
                <el-button v-if="canPrintSinglePrescription(section)" size="mini" class="vdd-single-print-btn"
                  @click.stop="printSinglePrescription(section)">打印</el-button>
              </div>

              <div class="drug-list">
                <el-row>
                  <el-col v-for="(item, itemIndex) in section.items" :key="item.key || itemIndex" class="drugItem"
                    :span="6">
                    <div class="drug-search read-only-cell">
                      <div class="search-top">
                        <span class="input-search">{{ item.label }}</span>
                        <div class="read-only-dose-wrap">
                          <span class="input-dosage">{{ item.value }}</span>
                        </div>
                      </div>
                      <div class="search-tips">
                        <span v-if="item.raw.isOwned && item.raw.isOwned == '1'">【自备】</span>
                        <span v-if="item.raw.handling">{{ item.raw.handling }}</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>

              <div class="drug-tips">
                <div class="drug-tips-left">
                  <span v-for="(text, tipIndex) in section.footerItems" :key="tipIndex" class="drug-tip-text">
                    {{ text }}
                  </span>
                </div>
                <div class="drug-tips-right">{{ section.footerRight }}</div>
              </div>
            </div>
          </div>
          <div v-for="(activity, activityIndex) in normalizedActivitySections" :key="activity.id || `activity-${activityIndex}`" class="vdd-activity-card">
            <div class="vdd-activity-header">
              <div class="vdd-activity-header-left">
                <img :src="imgArr.present" class="vdd-activity-icon" />
                <div class="vdd-activity-title">{{ activity.name }}</div>
                <div class="vdd-activity-description">共{{ activity.count }}套，总价￥{{ formatNumber(activity.totalPrice) }}</div>
              </div>
            </div>
            <div class="vdd-activity-list">
              <div v-for="(project, projectIndex) in activity.items" :key="project.key || projectIndex" class="vdd-activity-project">
                <div class="vdd-activity-project-header">
                  <div class="vdd-activity-project-index">{{ projectIndex + 1 }}</div>
                  <div class="vdd-activity-project-label">
                    <div class="vdd-activity-project-name">{{ activityProjectName(project) }}</div>
                    <div class="vdd-activity-project-type">{{ project.isPhysio ? '理疗' : '普通商品' }}</div>
                  </div>
                  <div v-if="!project.isPhysio" class="vdd-activity-project-count">
                    {{ activityProjectQuantity(project) }}{{ activityProjectUnit(project) }}
                  </div>
                  <div v-if="!project.isPhysio" class="vdd-activity-project-remark">
                    {{ project.raw.remark || '' }}
                  </div>
                </div>
                <template v-if="project.isPhysio">
                  <div v-if="hasAcupointList(project.raw)" class="vdd-activity-point-section">
                    <div class="vdd-activity-acupoint-list">
                      <div v-for="(acupoint, acupointIndex) in getAcupointList(project.raw)"
                        :key="acupoint.acupointId || acupointIndex" class="vdd-activity-acupoint-item">
                        <div class="vdd-activity-acupoint-type">{{ acupointLabel(acupoint) }}</div>
                        <div class="vdd-activity-acupoint-name">{{ acupoint.acupointName || '-' }}</div>
                      </div>
                    </div>
                    <div class="vdd-activity-acupoint-total">{{ acupointTotalText(project.raw) }}</div>
                  </div>
                  <div v-if="project.raw.physioExtendJson" class="vdd-activity-options">
                    <div class="vdd-activity-option-item">{{ displayPhysioSoldNum(project.raw) }}次</div>
                    <div v-if="isGroupedPhysio(project.raw)" class="vdd-activity-option-item">
                      1次{{ displayPhysioOnlyNum(project.raw) }}组
                    </div>
                    <div class="vdd-activity-option-item">{{ displayPhysioFrequency(project.raw) }}</div>
                    <div v-if="isGroupedPhysio(project.raw) && physioPerUnitCount(project.raw)" class="vdd-activity-option-tip">
                      每组{{ physioPerUnitCount(project.raw) }}个{{ physioPerUnitName(project.raw) }}，每次至少选择{{ displayPhysioMinCount(project.raw) }}个{{ physioPerUnitName(project.raw) }}
                    </div>
                    <div v-else-if="physioPerUnitCount(project.raw)" class="vdd-activity-option-tip">
                      每次至少选择{{ physioPerUnitCount(project.raw) }}个{{ physioPerUnitName(project.raw) }}
                    </div>
                    <div v-if="computedShowTips(project.raw)" class="vdd-activity-option-warning">
                      <span class="iconfont icon-jingg colorFE8F mr6"></span>选{{ physioOtherPerUnitName(project.raw) }}不计入已选数量
                    </div>
                  </div>
                  <div v-if="project.raw.remark" class="vdd-activity-remark">理疗备注：{{ project.raw.remark }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="visit-empty">暂无处方信息</div>
      </section>

      <section class="visit-section visit-advice-section">
        <div class="visit-section-title"><i />医嘱事项</div>
        <div class="advice-record">
          <p>
            <label>医嘱</label>
            <span>{{ recordValue('advice', 'doctorAdvice', 'medicalAdvice') }}</span>
          </p>
          <p>
            <label>复诊</label>
            <span>{{ revisitText }}</span>
          </p>
        </div>
      </section>
    </div>

    <span slot="footer" class="vdd-footer">
      <div class="vdd-footer-left" :style="{opacity: showInvoiceIssue ? 1 : 0}">
        <div class="issue">
          <div class="issue-value">
            <span class="issue-value-text" :class="{ 'green': String(issueStatus) !== '-1' }">{{ issueStatusText }}</span>
            <i class="el-icon-caret-bottom"></i>
            <div class="option">
              <div class="option-item" v-for="(item, index) in issueList" :key="index">
                <div class="option-item-title">{{ item.titleName }}</div>
                <div class="option-item-content" v-for="items in item.orderNumbers" :key="items.orderNumber">
                  <div class="option-item-content-orderNum">{{ items.orderNumber || '' }}</div>
                  <div
                    class="option-item-content-status"
                    :class="{
                      'green': ['0', 0].includes(items.invoiceStatus),
                      'gray': ['3', '6', 3, 6].includes(items.invoiceStatus)
                    }"
                  >{{ items.statusText }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vdd-footer-actions">
        <el-button type="primary" @click="handleFooterCommand('2')">打印处方</el-button>
        <el-button @click="handleFooterCommand('3')">打印病历</el-button>
        <el-button v-if="detailData.ybPay && orderInfo.status == 4" @click="handleFooterCommand('4')">打印医保结算单</el-button>
        <el-button v-if="detailData.ybPay && orderInfo.status == 4" @click="handleFooterCommand('5')">打印医疗收费清单</el-button>
        <el-button v-if="orderInfo.status == 4" @click="handleFooterCommand('1')">打印收费小票</el-button>
        <el-button v-if="orderInfo.status == 4" @click="handleFooterCommand('6')">打印发票</el-button>
      </div>
    </span>

    <print-dialog v-show="printDialogShow" ref="printDia" :printDialogShow="printDialogShow" :append-to-body="true"
      :isBatch="isBatch" :printListObj="printListObj" :id="printOrderId" :areaId="printAreaId"
      :orderType="printorderType" :printType="printType" @setPrintDiaShow="setPrintDiaShow"
      @closePrintPrescription="closePrintPrescription" @printSuccess="printSuccess"
      @printSuccessBatch="printSuccessBatch" />
    <invoice-detail ref="invoiceDetail" :append-to-body="true" @print="invoicePrint" />
  </el-dialog>
</template>

<script>
import { getOutpatientAllDetailApi } from '@/api/outpatientDetail'
import { getCaseFieldAllApi } from '@/api/patient'
import { getDict } from '@/api/common'
import { payDTO } from '@/DTO/index'
import { outpatientStatus } from '@/utils/const'
import { imgArr } from '@/assets/images/img'
import { dictText } from '@/utils/validateBase'
import printDialog from '@/components/printDialog'
import InvoiceDetail from '@/components/Pricing/InvoiceDetail.vue'

export default {
  name: 'VisitDetailDialog',
  components: {
    printDialog,
    InvoiceDetail,
  },
  inheritAttrs: false,
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
    title: {
      type: String,
      default: '门诊详情',
    },
    width: {
      type: String,
      default: '900px',
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      detailData: {},
      imgArr,
      printDialogShow: false,
      printOrderId: '',
      printorderType: '',
      printType: '',
      printListObj: [],
      isBatch: false,
      printAreaId: '',
      invoiceVisible: false,
      issueList: [],
      issueStatus: -1,
      issueStatusText: '未开票',
      caseList: [],
      caseFieldLoaded: false,
      dictData: {
        useFrequency: [],
        takingTime: [],
        intervalRequirement: [],
        singleDoseUnit: [],
      },
      dictDataLoaded: false,
      acupointType: [
        { label: '单', value: 10 },
        { label: '双', value: 20 },
        { label: '左', value: 30 },
        { label: '右', value: 40 },
      ],
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    orderDetail() {
      return this.detailData.orderDetail || {}
    },
    patientInfo() {
      return this.orderDetail.patient || this.detailData.patient || this.detailData.patientInfo || {}
    },
    doctorInfo() {
      return this.orderDetail.doctor || this.detailData.doctor || this.detailData.doctorInfo || {}
    },
    orderInfo() {
      return this.orderDetail.order || this.detailData.order || this.detailData.orderInfo || {}
    },
    caseInfo() {
      return this.detailData.orderCaseDiagnosis || this.detailData.caseDiagnosis || this.detailData.caseInfo || {}
    },
    patientName() {
      return this.firstValid([this.patientInfo.patientName, this.patientInfo.name], '-')
    },
    patientSexText() {
      const sex = this.patientInfo.sex
      if (sex === '0' || sex === 0) return '男'
      if (sex === '1' || sex === 1) return '女'
      return '-'
    },
    patientAgeText() {
      const age = this.patientInfo.age || this.patientInfo.year
      const ageMth = this.patientInfo.ageMth || this.patientInfo.month
      if (age === undefined || age === null || age === '') return '-'
      const ageLabel = `${age}岁`
      if (ageMth !== undefined && ageMth !== null && ageMth !== '' && Number(ageMth) !== 0) {
        return `${ageLabel}${ageMth}月`
      }
      return ageLabel
    },
    overviewList() {
      return [
        {
          label: '就诊医馆',
          value: this.firstValid([
            this.orderInfo.deptName,
          ]),
        },
        {
          label: '接诊医生',
          value: this.firstValid([
            this.doctorInfo.doctorName,
          ]),
        },
        {
          label: '就诊时间',
          value: this.firstValid([
            this.$moment(this.orderInfo.createTime).format('YYYY-MM-DD HH:mm:ss'),
          ]),
        },
      ]
    },
    statusInfo() {
      const status = this.orderInfo.status
      const matched = outpatientStatus.find(item => item.id == status)
      if (matched) return matched
      return {
        id: status,
        name: this.firstValid([status]),
        tag: 'parTag',
      }
    },
    diagnosisText() {
      const diagnosisList = this.caseInfo.diagnosisList
      if (Array.isArray(diagnosisList) && diagnosisList.length) {
        return diagnosisList.map(item => item.diagnoseName || item.name).filter(Boolean).join('；') || '-'
      }
      return this.recordValue('diagnosis', 'diagnose', 'diagnosisName')
    },
    medicalRecordItems() {
      const rows = []
      const fields = this.normalizedChooseCaseList
      fields.forEach(field => {
        if (field === 'diagnosis' || field === 'images' || field === 'doctorAdvice' || field === 'preNotes' || field === 'specialRemark') return
        const value = this.getCaseDisplayValue(field)
        rows.push({
          field,
          label: this.caseFieldName(field),
          value,
          html: field === 'menstrualHistory',
        })
      })
      if (!rows.some(item => item.field === 'diagnosis')) {
        rows.push({
          field: 'diagnosis',
          label: this.caseFieldName('diagnosis'),
          value: this.diagnosisText,
        })
      }
      return rows
    },
    normalizedChooseCaseList() {
      // 详情页展示全部病历字段，不按登录人配置裁剪
      const fields = Array.isArray(this.caseList) && this.caseList.length
        ? this.caseList.map(item => item && item.propertyName).filter(Boolean)
        : ['patientTell', 'presentCondition', 'previousHistory', 'facePalpation', 'diagnosis', 'dialectical']
      return fields.filter((field, index) => field && fields.indexOf(field) === index)
    },
    caseImageList() {
      const images = this.getCaseRawValue('imgs', 'images')
      if (Array.isArray(images)) return images.filter(Boolean)
      if (typeof images === 'string') return images.split(',').map(item => item.trim()).filter(Boolean)
      return []
    },
    revisitText() {
      const flag = this.orderInfo.revisitFlag
      const revisitTime = this.orderInfo.revisitTime || this.caseInfo.revisitTime
      const notes = this.orderInfo.revisitNotes || this.caseInfo.revisitNotes || this.caseInfo.revisitAdvice || this.caseInfo.reviewAdvice
      if (flag === '1' || flag === 1) {
        return [revisitTime, notes].filter(Boolean).join('，') || '-'
      }
      return notes || '-'
    },
    
    showInvoiceIssue() {
      return [4, -7].includes(this.orderInfo.status)
    },
    recipeList() {
      return this.detailData.projectRecipes || this.detailData.paymentRecipes || this.detailData.recipesList || this.detailData.recipes || []
    },
    normalizedActivitySections() {
      const activityList = []
      const addActivities = list => {
        if (!Array.isArray(list)) return
        list.forEach(activity => {
          if (activity && typeof activity === 'object') activityList.push(activity)
        })
      }
      const addActivitySources = source => {
        if (!source || typeof source !== 'object') return
        addActivities(source.actGroups)
        if (source.actNumber && Array.isArray(source.items)) addActivities([source])
      }

      addActivitySources(this.detailData)
      addActivitySources(this.orderDetail)
      const nestedRecipes = Array.isArray(this.recipeList) ? this.recipeList : []
      nestedRecipes.forEach(recipe => addActivitySources(recipe))

      const seen = {}
      return activityList
        .filter((activity, index) => {
          const key = activity.actNumber || activity.activityNumber || activity.activityId || activity.id
          if (key === undefined || key === null || key === '') return true
          if (seen[key]) return false
          seen[key] = true
          return true
        })
        .map((activity, index) => this.normalizeActivity(activity, index))
        .filter(activity => activity.items.length || activity.name || activity.totalPrice !== '')
    },
    normalizedPrescriptionSections() {
      const counters = {}
      return (Array.isArray(this.recipeList) ? this.recipeList : [])
        .filter(Boolean)
        .map((recipe, index) => {
          const recipeType = this.getRecipeTypeKey(recipe)
          counters[recipeType] = (counters[recipeType] || 0) + 1
          return this.normalizeRecipe(recipe, index, counters[recipeType])
        })
        .filter(section => section && (section.kind !== 'other' || section.items.length > 0) && (section.items.length || section.footerItems.length || section.footerRight))
        .sort((a, b) => {
          const priorityDiff = this.getRecipeDisplayPriority(a.raw) - this.getRecipeDisplayPriority(b.raw)
          if (priorityDiff !== 0) return priorityDiff
          return a.originalIndex - b.originalIndex
        })
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDetail()
          this.getAllCaseList()
        }
      },
    },
  },
  methods: {
    async getDetail() {
      if (!this.orderId) {
        this.detailData = {}
        return
      }
      const currentOrderId = this.orderId
      this.loading = true
      try {
        const { code, data } = await getOutpatientAllDetailApi({ orderId: currentOrderId })
        if (currentOrderId != this.orderId) return
        if (code === 200) {
          this.detailData = data || {}
          this.$emit('loaded', this.detailData)
          await this.getInvoiceInfo(currentOrderId)
        } else {
          this.detailData = {}
          this.issueList = []
          this.issueStatus = -1
          this.issueStatusText = '未开票'
        }
      } catch (error) {
        if (currentOrderId == this.orderId) {
          this.detailData = {}
          this.$message && this.$message.error('获取门诊详情失败')
        }
      } finally {
        if (currentOrderId == this.orderId) this.loading = false
      }
    },
    async getAllCaseList() {
      if (this.caseFieldLoaded) return
      this.caseFieldLoaded = true
      try {
        const res = await getCaseFieldAllApi()
        if (res && res.code === 200) {
          this.caseList = res.data || []
        }
        await this.getDictData()
      } catch (error) {
        this.caseFieldLoaded = false
      }
    },
    async getDictData() {
      if (this.dictDataLoaded) return
      this.dictDataLoaded = true
      try {
        const [useFrequencyRes, takingTimeRes, intervalRequirementRes, singleDoseUnitRes] = await Promise.all([
          getDict('useFrequency'),
          getDict('takingTime'),
          getDict('intervalRequirement'),
          getDict('singleDoseUnit'),
        ])
        if (useFrequencyRes && useFrequencyRes.code === 200) {
          this.dictData.useFrequency = useFrequencyRes.data || []
        }
        if (takingTimeRes && takingTimeRes.code === 200) {
          this.dictData.takingTime = takingTimeRes.data || []
        }
        if (intervalRequirementRes && intervalRequirementRes.code === 200) {
          this.dictData.intervalRequirement = intervalRequirementRes.data || []
        }
        if (singleDoseUnitRes && singleDoseUnitRes.code === 200) {
          this.dictData.singleDoseUnit = singleDoseUnitRes.data || []
        }
      } catch (error) {
        this.dictDataLoaded = false
      }
    },
    async getInvoiceInfo(orderId = this.orderId) {
      this.issueStatusText = '未开票'
      this.issueList = []
      try {
        const { code, data } = await payDTO.getInvoiceList({ orderId })
        if (code === 200 && data) {
          this.getIssueInfo(data)
        }
      } catch (error) { }
    },
    getIssueInfo(invoiceResponse) {
      const issueStatusInfo = {
        '-1': '待开票',
        '0': '已开票',
        '2': '待开票',
        '3': '已红冲',
        '6': '已作废',
      }
      const issueOrderStatusInfo = {
        '-1': '未开票',
        '0': '部分开票',
        '1': '已开票',
      }
      const orderTypeNameInfo = {
        '1': '中药处方',
        '2': '理疗处方',
        '3': '隐秘处方',
        '4': '非处方项目',
        '15': '中成药处方'
      }
      const orderTypeSortList = ['1', '15', '2', '4', '3']
      const { status, detailList } = invoiceResponse || {}
      this.issueStatus = status
      this.issueStatusText = issueOrderStatusInfo[String(status)] || '未开票'
      const safeDetailList = Array.isArray(detailList) ? detailList : []
      const recipeTypeList = [...new Set(safeDetailList.map(item => item.recipeType))]
      const obj = {}
      recipeTypeList.forEach(el => {
        const sortList = safeDetailList.filter(item => item.recipeType === el).sort((a, b) => a.sort - b.sort)
        obj[el] = sortList.map((item, index) => ({
          ...item,
          titleName: orderTypeNameInfo[el] + (sortList.length > 1 ? (index + 1) : ''),
          orderNumbers: (item.orderNumbers || []).map(items => ({
            ...items,
            statusText: issueStatusInfo[String(items.invoiceStatus)] || ''
          }))
        }))
      })
      this.issueList = orderTypeSortList.map(item => obj[item]).flat().filter(item => !!item)
    },
    handleBeforeClose(done) {
      this.dialogVisible = false
      this.$emit('close')
      if (done) done()
    },
    setPrintDiaShow() {
      this.printDialogShow = true
    },
    closePrintPrescription() {
      this.printDialogShow = false
    },
    printSuccess() {
      this.printDialogShow = false
    },
    printSuccessBatch() {
      this.printDialogShow = false
    },
    handleFooterCommand(command) {
      if (!this.orderId || this.loading) return
      switch (command) {
        case '1':
          this.openPrintDialog({ id: this.orderId, orderType: '4', printType: '1' })
          break
        case '2':
          this.printPrescription()
          break
        case '3':
          this.openPrintDialog({ id: this.orderId, orderType: '4', printType: '6' })
          break
        case '4':
          this.openPrintDialog({ id: this.orderId, orderType: '1', printType: '8' })
          break
        case '5':
          this.openPrintDialog({ id: this.orderId, orderType: '1', printType: '7' })
          break
        case '6':
          if (this.$refs.invoiceDetail) {
            this.$refs.invoiceDetail.open(this.orderId)
          }
          break
      }
    },
    openPrintDialog(printMap) {
      this.printDialogShow = false
      this.isBatch = false
      this.printListObj = []
      this.printOrderId = printMap.id || ''
      this.printorderType = printMap.orderType || ''
      this.printType = printMap.printType || ''
      this.printAreaId = printMap.areaId || ''
      this.$nextTick(() => {
        this.$refs.printDia && this.$refs.printDia.useDefaultPrint(printMap)
      })
    },
    printPrescription() {
      const printListObj = []
      this.normalizedPrescriptionSections.forEach(section => {
        const raw = section.raw || {}
        if (String(raw.recipeType) === '0') return
        const recipeId = this.getRecipePrintId(raw)
        if (!recipeId) return
        printListObj.push({
          printType: '2',
          id: recipeId,
          orderType: String(raw.recipeType) === '3' ? '2' : '1',
        })
      })
      if (!printListObj.length) {
        this.$message && this.$message.warning('暂无可打印的处方')
        return
      }
      this.isBatch = true
      this.printType = '2'
      this.printListObj = printListObj
      this.printOrderId = ''
      this.printorderType = ''
      this.printAreaId = ''
      this.$nextTick(() => {
        this.$refs.printDia && this.$refs.printDia.useDefaultPrint()
      })
    },
    canPrintSinglePrescription(section) {
      const raw = section && section.raw ? section.raw : {}
      return String(raw.recipeType) !== '0' && !!this.getRecipePrintId(raw)
    },
    printSinglePrescription(section) {
      if (this.loading) return
      const raw = section && section.raw ? section.raw : {}
      const recipeId = this.getRecipePrintId(raw)
      if (!recipeId) {
        this.$message && this.$message.warning('暂无可打印的处方')
        return
      }
      this.isBatch = false
      this.printListObj = []
      this.printOrderId = recipeId
      this.printType = '2'
      this.printorderType = ![undefined, null, ''].includes(raw.actNumber) || String(raw.recipeType) === '3' ? '2' : '1'
      this.printAreaId = ''
      this.$nextTick(() => {
        this.$refs.printDia && this.$refs.printDia.useDefaultPrint()
      })
    },
    invoicePrint(orderId) {
      this.printInvoice(orderId || this.orderId)
    },
    printInvoice(orderId) {
      this.openPrintDialog({ id: orderId, orderType: '21', printType: '1' })
    },
    getRecipePrintId(recipe) {
      return recipe.recipeId || recipe.orderCaseProjectRecipeId || recipe.caseProjectRecipeId || recipe.orderPaymentRecipeId || recipe.id || recipe.itemId || ''
    },
    normalizeRecipe(recipe, index, typeIndex) {
      if (typeof recipe === 'string') {
        return {
          id: index,
          kind: 'drug',
          raw: { recipeType: 'default' },
          originalIndex: index,
          title: `处方${index + 1}`,
          iconSrc: this.imgArr.drugIcon,
          totalText: '',
          items: [],
          footerItems: [],
          footerRight: '',
        }
      }

      const kind = this.getRecipeKind(recipe)
      const sourceItems = recipe.items || recipe.recipeDrugItem || recipe.recipePhysioItem || recipe.recipeChineseMedicineItem || recipe.recipeOtherItem || recipe.otherItems || recipe.comboItems || recipe.list || []
      const items = this.normalizeRecipeItems(sourceItems, kind)
      return {
        id: recipe.id || recipe.recipeId || recipe.caseProjectRecipeId || recipe.orderCaseProjectRecipeId || recipe.orderPaymentRecipeId || index,
        raw: recipe,
        originalIndex: index,
        kind,
        cardClass: kind === 'physio' ? 'is-physio-card' : kind === 'chinese' ? 'is-chinese-card' : kind === 'other' ? 'is-other-card' : 'is-drug-card',
        title: this.getRecipeTitle(recipe, typeIndex),
        iconSrc: this.getRecipeIconSrc(recipe, kind),
        totalText: this.getRecipeHeaderText(recipe, kind),
        items,
        footerItems: this.getRecipeFooterItems(recipe, kind),
        footerRight: this.getRecipeFooterRight(recipe),
      }
    },
    normalizeActivity(activity, index) {
      const source = activity || {}
      const sourceItems = Array.isArray(source.items)
        ? source.items
        : Array.isArray(source.projectItems)
          ? source.projectItems
          : Array.isArray(source.activityItems)
            ? source.activityItems
            : []
      const items = sourceItems.filter(Boolean).map((item, itemIndex) => {
        const raw = typeof item === 'object' ? { ...item } : { itemName: item }
        const isPhysio = raw.drugType == 1
        if (isPhysio) raw.physioExtendJson = this.normalizePhysioExtendJson(raw)
        return {
          key: raw.spuId || raw.itemId || raw.id || itemIndex,
          raw,
          isPhysio,
        }
      })
      return {
        id: source.actNumber || source.activityNumber || source.activityId || source.id || index,
        raw: source,
        name: this.firstValid([source.actCseName, source.activityName, source.cseName, source.name], '活动套餐'),
        count: this.firstValid([source.actCount, source.count, source.activityCount], 0),
        totalPrice: this.firstValid([source.totalPrice, source.amount, source.price], ''),
        items,
      }
    },
    activityProjectName(project) {
      const item = project && project.raw ? project.raw : {}
      return this.firstValid([
        item.spuCommonName,
        item.itemName,
        item.drugName,
        item.physioName,
        item.projectName,
        item.goodsName,
        item.name,
      ], '-')
    },
    activityProjectQuantity(project) {
      const item = project && project.raw ? project.raw : {}
      return this.firstValid([item.itemNum, item.num, item.quantity, item.number], 0)
    },
    activityProjectUnit(project) {
      const item = project && project.raw ? project.raw : {}
      return this.firstValid([item.itemUnit, item.unit, item.stockUnit], '')
    },
    getRecipeTypeKey(recipe) {
      return String(recipe && recipe.recipeType !== undefined && recipe.recipeType !== null ? recipe.recipeType : 'default')
    },
    getRecipeKind(recipe) {
      const type = this.getRecipeTypeKey(recipe)
      if (type === '0') return 'other'
      if (type === '3') return 'physio'
      if (type === '4') return 'chinese'
      if (type === '2') return 'combo'
      return 'drug'
    },
    getRecipeDisplayPriority(recipe) {
      const type = this.getRecipeTypeKey(recipe)
      const priorityMap = {
        1: 10,
        3: 20,
        4: 30,
        0: 40,
      }
      return priorityMap[type] || 90
    },
    getRecipeTitle(recipe, typeIndex) {
      if (recipe.recipeType == 0) return typeIndex > 1 ? `非处方项目 ${typeIndex}` : '非处方项目'
      const recipeTypeMap = {
        0: '非处方项目',
        1: '中药处方',
        3: '理疗处方',
        4: '中成药处方',
      }
      const title = recipeTypeMap[recipe.recipeType] || '处方'
      if (recipe.recipeType == 3 || recipe.recipeType == 4) return `${title} ${typeIndex}`
      return `${title}${typeIndex}`
    },
    getRecipeIconSrc(recipe, kind) {
      if (kind === 'physio') return this.imgArr.phyIcon
      if (kind === 'combo') return this.imgArr.comboIcon
      if (kind === 'chinese') return this.imgArr.chineseMedicineIcon
      return this.imgArr.drugIcon
    },
    getRecipeHeaderText(recipe, kind) {
      if (kind === 'physio' || kind === 'chinese' || kind === 'other') {
        return !recipe.recipeAmount ? '' : `总价￥${this.formatNumber(recipe.recipeAmount)}`
      }
      return [
        recipe.items ? `${recipe.items.length}味` : '',
        recipe.weight ? `单剂${recipe.weight}g` : '',
        recipe.weight ? `合计${this.$bigNumber(recipe.doseNum, '*', recipe.weight)}g` : '',
      ].filter(Boolean).join('，')
    },
    getRecipeFooterItems(recipe, kind) {
      if (kind === 'chinese') {

      }
      if (kind === 'physio') {
        return [
          recipe.soldNum ? `${recipe.soldNum}次` : '',
          recipe.onlyNum ? `1次${recipe.onlyNum}${recipe.unit || '组'}` : '',
          recipe.executeDesc || recipe.frequency || recipe.intervalDesc || '',
          recipe.remark || '',
        ].filter(Boolean)
      }
      return [
        recipe.doseNum ? `${recipe.doseNum}剂` : '',
        recipe.recipeMethod || '',
        recipe.doseFrequency || '',
        recipe.frequency || '',
        recipe.bakingPowderDosage || '',
        recipe.pelletizingDosage || '',
        recipe.wrapTime || '',
        recipe.creamDosage || '',
        recipe.takingDosage || '',
        recipe.mixingBagNum ? `每次${recipe.mixingBagNum}袋` : '',
        recipe.takingDays || '',
        recipe.recipeMoment || '',
        recipe.applicationTime || '',
        recipe.remark || '',
      ].filter(Boolean)
    },
    getRecipeFooterRight(recipe) {
      return !recipe.recipeAmount === '' ? '' : `￥${this.formatNumber(recipe.recipeAmount)}`
    },
    hasOtherRecipeItem(item) {
      if (typeof item === 'string') return item.trim() !== ''
      if (!item || typeof item !== 'object') return false
      const name = this.firstValid([
        item.itemName,
        item.projectName,
        item.goodsName,
        item.drugName,
        item.medicineName,
        item.name,
      ], '')
      return String(name).trim() !== ''
    },
    normalizeRecipeItems(items, kind) {
      return (Array.isArray(items) ? items : [])
        .filter(item => kind !== 'other' || this.hasOtherRecipeItem(item))
        .map((item, index) => {
        if (typeof item === 'string') {
          return {
            key: index,
            raw: { itemName: item },
            label: item,
            value: '',
            prefix: '双',
          }
        }
        const raw = { ...item }
        if (kind === 'physio') {
          raw.physioExtendJson = this.normalizePhysioExtendJson(raw)
        }
        const label = this.firstValid([
          raw.drugName,
          raw.medicineName,
          raw.physioName,
          raw.itemName,
          raw.goodsName,
          raw.name,
          raw.title,
        ], '-')
        const prefix = this.firstValid([
          raw.prefix,
          raw.positionName,
          raw.partName,
          raw.side,
          raw.acupointSide,
        ], '双')
        return {
          key: raw.id || raw.itemId || raw.drugId || raw.physioId || index,
          raw,
          label,
          value: this.getItemValue(raw),
          prefix: kind === 'physio' ? prefix : '',
        }
      })
    },
    normalizePhysioExtendJson(item) {
      let extend = item.physioExtendJson || {}
      if (typeof extend === 'string') {
        try {
          extend = JSON.parse(extend) || {}
        } catch (error) {
          extend = {}
        }
      }
      extend = { ...extend }
      extend.executionMode = this.firstValid([extend.executionMode, item.executionMode], '')
      extend.onlyNum = this.firstValid([extend.onlyNum, item.onlyNum], '')
      extend.perUnit = this.firstValid([extend.perUnit, item.perUnit], '')
      extend.perUnitCount = this.firstValid([extend.perUnitCount, item.perUnitCount], '')
      extend.physioIntervalEnum = this.firstValid([extend.physioIntervalEnum, item.physioIntervalEnum], '')
      extend.soldNum = this.firstValid([extend.soldNum, item.soldNum], '')
      const acupointList = extend.acupointinfoList || item.acupointinfoList || item.acupointList || []
      extend.acupointinfoList = Array.isArray(acupointList) ? acupointList : []
      return extend
    },
    getItemValue(item) {
      const number = item.number || item.num || item.quantity || item.itemNum
      const unit = item.unit || item.itemUnit || item.stockUnit || ''
      if (number !== undefined && number !== null && number !== '') return `${number}${unit}`
      return this.firstValid([
        item.dosage,
        item.dose,
        item.value,
        item.desc,
        item.specifications,
        item.executeDesc,
      ], '')
    },
    formatNumber(value, fallback = '0.00') {
      if (value === undefined || value === null || value === '') return fallback
      const number = Number(value)
      if (Number.isNaN(number)) return value
      return number.toFixed(2)
    },
    toNumber(value) {
      if (value === undefined || value === null || value === '') return null
      const number = Number(value)
      return Number.isNaN(number) ? null : number
    },
    multiplyAmount(a, b) {
      const numberA = this.toNumber(a)
      const numberB = this.toNumber(b)
      if (numberA === null || numberB === null) return ''
      return this.formatNumber(numberA * numberB)
    },
    displayChineseTotal(item) {
      const total = this.firstValid([item.totalPrice, item.amount, item.cost], '')
      if (total !== '') return this.formatNumber(total)
      const quantity = this.firstValid([item.itemNum, item.num, item.quantity], 1)
      return this.multiplyAmount(item.price, quantity) || this.formatNumber(0)
    },
    displayOtherName(item, label) {
      const name = this.firstValid([item.itemName, item.projectName, item.goodsName, item.name, label], '-')
      return item.commodityType === 1 ? `${name}（赠品）` : name
    },
    displayOtherTotal(item) {
      const total = this.firstValid([item.totalPrice, item.amount, item.cost], '')
      if (total !== '') return this.formatNumber(total)
      const quantity = this.firstValid([item.itemNum, item.num, item.quantity], 1)
      return this.multiplyAmount(item.price, quantity) || this.formatNumber(0)
    },
    displayPhysioUnitLabel(item) {
      const extend = item.physioExtendJson || {}
      if (extend.executionMode == 20) return '组'
      return '次'
    },
    displayPhysioUnitAmount(item) {
      const extend = item.physioExtendJson || {}
      if (extend.executionMode == 20) {
        return this.multiplyAmount(item.price, this.displayPhysioOnlyNum(item)) || this.formatNumber(item.price)
      }
      return this.formatNumber(item.price)
    },
    displayPhysioTotal(item) {
      const total = this.firstValid([item.totalPrice, item.amount, item.cost], '')
      if (total !== '') return this.formatNumber(total)
      const quantity = this.firstValid([item.itemNum, item.num, item.quantity, this.displayPhysioSoldNum(item)], 1)
      return this.multiplyAmount(item.price, quantity) || this.formatNumber(0)
    },
    displayPhysioSoldNum(item) {
      const extend = item.physioExtendJson || {}
      return this.firstValid([extend.soldNum, item.soldNum, item.itemNum, item.num, item.quantity], 1)
    },
    displayPhysioOnlyNum(item) {
      const extend = item.physioExtendJson || {}
      return this.firstValid([extend.onlyNum, item.onlyNum], 3)
    },
    displayPhysioFrequency(item) {
      const extend = item.physioExtendJson || {}
      return this.firstValid([item.executeDesc, extend.executeDesc, item.frequency, extend.physioIntervalEnum], '-')
    },
    isGroupedPhysio(item) {
      const extend = item.physioExtendJson || {}
      return extend.executionMode == 20
    },
    physioPerUnitCount(item) {
      const extend = item.physioExtendJson || {}
      return this.firstValid([extend.perUnitCount, item.perUnitCount], '')
    },
    physioPerUnitName(item) {
      const extend = item.physioExtendJson || {}
      return extend.perUnit == 20 ? '部位' : '穴位'
    },
    physioOtherPerUnitName(item) {
      const extend = item.physioExtendJson || {}
      return extend.perUnit == 20 ? '穴位' : '部位'
    },
    displayPhysioMinCount(item) {
      const count = this.physioPerUnitCount(item)
      if (!count) return ''
      if (this.isGroupedPhysio(item)) {
        return this.multiplyPlain(count, this.displayPhysioOnlyNum(item))
      }
      return count
    },
    multiplyPlain(a, b) {
      const numberA = this.toNumber(a)
      const numberB = this.toNumber(b)
      if (numberA === null || numberB === null) return ''
      return numberA * numberB
    },
    hasPhysioMeta(item) {
      const extend = item.physioExtendJson || {}
      return Boolean(
        extend.executionMode ||
        extend.soldNum ||
        extend.onlyNum ||
        extend.perUnitCount ||
        item.executeDesc ||
        item.totalPrice ||
        item.amount ||
        item.cost
      )
    },
    getAcupointList(item) {
      const extend = item.physioExtendJson || {}
      return Array.isArray(extend.acupointinfoList) ? extend.acupointinfoList : []
    },
    hasAcupointList(item) {
      return this.getAcupointList(item).length > 0
    },
    acupointLabel(acupoint) {
      if (!acupoint) return '-'
      if (acupoint.type == 50) {
        return Array.isArray(acupoint.typeExtend) && acupoint.typeExtend.length ? acupoint.typeExtend[0] : 0
      }
      if (acupoint.type == 60) {
        return Array.isArray(acupoint.typeExtend) ? acupoint.typeExtend.length : 0
      }
      const matched = this.acupointType.find(item => item.value == acupoint.type)
      return matched ? matched.label : '-'
    },
    computedPerUnitCount(physioExtendJson) {
      if (!physioExtendJson || !Array.isArray(physioExtendJson.acupointinfoList)) return 0
      let num = 0
      const perUnit = physioExtendJson.perUnit
      physioExtendJson.acupointinfoList.forEach(item => {
        if (perUnit && item.speciesType != perUnit) return
        if (item.type == 60) {
          num += Array.isArray(item.typeExtend) ? item.typeExtend.length : 0
        } else if (item.type == 50) {
          const first = Array.isArray(item.typeExtend) ? item.typeExtend[0] : 0
          num += Number(first || 0)
        } else if (item.type == 20) {
          num += 2
        } else {
          num += 1
        }
      })
      return num
    },
    computedShowTips(item) {
      const extend = item.physioExtendJson || {}
      const acupointList = this.getAcupointList(item)
      if (!extend.perUnit || !acupointList.length) return false
      return acupointList.some(acupoint => acupoint.speciesType != extend.perUnit)
    },
    acupointTotalText(item) {
      const extend = item.physioExtendJson || {}
      const label = extend.perUnit ? this.physioPerUnitName(item) : '已选'
      const selected = this.computedPerUnitCount(extend)
      if (extend.executionMode && extend.perUnitCount) {
        const total = this.multiplyPlain(extend.perUnitCount, extend.onlyNum || 1)
        return `${label}：${selected} / ${total}`
      }
      return `${label}：${selected}`
    },
    caseFieldName(field) {
      const matched = this.caseList.find(item => item.propertyName === field)
      if (matched && matched.displayName) return matched.displayName
      const labelMap = {
        patientTell: '主诉',
        presentCondition: '现病史',
        previousHistory: '既往病史',
        familyHistory: '家族史',
        allergyHistory: '过敏史',
        menstrualHistory: '月经史',
        accessoryExamination: '辅助检查',
        physicalExamination: '体格检查',
        facePalpation: '望闻切诊',
        dialectical: '辨证',
        diagnosis: '诊断',
        specialRemark: '特殊备注',
      }
      return labelMap[field] || field
    },
    getCaseDisplayValue(field) {
      if (field === 'diagnosis') return this.diagnosisText
      if (field === 'menstrualHistory') return this.formatMenstrualHistory(this.getCaseRawValue(field))
      const value = this.getCaseRawValue(field)
      if (Array.isArray(value)) return value.filter(Boolean).join('，') || '-'
      if (this.isPlainObject(value)) return Object.values(value).filter(Boolean).join('，') || '-'
      if (value === undefined || value === null || value === '') return '-'
      return value
    },
    getCaseRawValue(...keys) {
      if (!this.caseInfo || typeof this.caseInfo !== 'object') return ''
      for (const key of keys) {
        const value = this.caseInfo[key]
        if (value !== undefined && value !== null && value !== '') return value
      }
      return ''
    },
    formatMenstrualHistory(value) {
      if (value === undefined || value === null || value === '') return '-'
      let menstrualHistory = value
      if (typeof menstrualHistory === 'string') {
        const text = menstrualHistory.trim()
        if (!text) return '-'
        if (text[0] !== '[' && text[0] !== '{') return this.escapeHtml(text)
        try {
          menstrualHistory = JSON.parse(text)
        } catch (error) {
          return this.escapeHtml(text)
        }
      }
      if (!Array.isArray(menstrualHistory)) {
        menstrualHistory = this.isPlainObject(menstrualHistory) ? [menstrualHistory] : []
      }
      const htmlList = []
      menstrualHistory.forEach(item => {
        if (!this.isPlainObject(item)) {
          const text = this.escapeHtml(item)
          if (!text || text === '，' || text === '&lt;br&gt;') return
          htmlList.push(`<span>${text}</span>`)
          return
        }
        switch (item.type) {
          case 'text': {
            const text = this.escapeHtml(item.text || '')
            if (!text || text === '，' || text === '&lt;br&gt;') return
            htmlList.push(`<span>${text}</span>`)
            break
          }
          case 'pregnant': {
            if (item.text === '<br>' || item.pregnancyNum === '<br>' || item.childbirthNum === '<br>') return
            const pregnancyNum = item.pregnancyNum || ''
            const childbirthNum = item.childbirthNum || ''
            if (pregnancyNum === '' && childbirthNum === '') return
            htmlList.push(`<span id="pregnant">孕${this.escapeHtml(pregnancyNum)} 产${this.escapeHtml(childbirthNum)}</span>`)
            break
          }
          case 'menstruation': {
            if (this.isNullish(item.menarcheAge)) return
            const menarcheAge = this.escapeHtml(item.menarcheAge)
            const menstruationDays = this.escapeHtml(this.formatMenstrualRange(item.menstruationDays))
            const menstrualCycle = this.escapeHtml(this.formatMenstrualRange(item.menstrualCycle))
            const menopauseDate = this.isNullish(item.menopauseDate) ? '' : `<span id="menopauseDate">LMP ${this.escapeHtml(item.menopauseDate)}</span>`
            const menopauseAge = this.isNullish(item.menopauseAge) ? '' : `<span class="ml8" id="menopauseAge">${this.escapeHtml(item.menopauseAge)}</span>`
            htmlList.push(`<span id="menstruation" class="flex align-i-c"><span id="menarcheAge">${menarcheAge}</span><span class="flex flex-col w40 size12 tac ml8 mr8"> <span id="menstruationDays">${menstruationDays}</span> <span class="frasl"></span><span id="menstrualCycle">${menstrualCycle}</span></span>${menopauseDate}${menopauseAge}</span>`)
            break
          }
          default: {
            const text = Object.values(item)
              .filter(val => typeof val !== 'object' && val !== undefined && val !== null && val !== '')
              .map(val => this.escapeHtml(val))
              .join(' ')
            if (!text) return
            htmlList.push(`<span>${text}</span>`)
          }
        }
      })
      if (!htmlList.length) return '-'
      return htmlList.join('<span>，</span>')
    },
    formatMenstrualRange(value) {
      if (!Array.isArray(value)) return value || ''
      if (value.length === 1) return value[0]
      if (value.length >= 2) return `${value[0]}~${value[1]}`
      return ''
    },
    isPlainObject(value) {
      return Object.prototype.toString.call(value) === '[object Object]'
    },
    isNullish(value) {
      return value === undefined || value === null || value === ''
    },
    escapeHtml(value) {
      const text = value === undefined || value === null ? '' : String(value)
      return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
    },
    recordValue(...keys) {
      return this.getField(this.caseInfo, ...keys)
    },
    displayDictValue(value, list) {
      if (!value) return '-'
      const item = list && list.length ? list.find(item => item.dictCode == value) : null
      return item ? item.dictLabel : '-'
    },
    getField(source, ...keys) {
      if (!source || typeof source !== 'object') return '-'
      for (const key of keys) {
        const value = source[key]
        if (value !== undefined && value !== null && value !== '') return value
      }
      return '-'
    },
    firstValid(values, fallback = '-') {
      for (const value of values) {
        if (value !== undefined && value !== null && value !== '') return value
      }
      return fallback
    },
  },
}
</script>

<style lang="less">
@borderColor: #E0E0E0;
@fontColor: #1890FF;

.vdd-dialog {
  border-radius: 10px;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;

  .el-dialog__header {
    flex: none;
    height: 48px;
    padding: 0 16px 0 20px;
    line-height: 48px;
    border-bottom: 1px solid #ebeaee;
  }

  .el-dialog__title {
    color: #1f2329;
    font-size: 16px;
    font-weight: 600;
  }

  .el-dialog__headerbtn {
    top: 14px;
    right: 16px;
  }

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
    color: #303133;
    font-size: 13px;
    word-break: break-all;
  }

  .el-dialog__footer {
    flex: none;
    padding: 0;
  }
}

.vdd-dialog .visit-detail-panel {
  max-height: calc(90vh - 48px - 63px);
  overflow-y: auto;
  padding: 16px 20px 20px;
  color: #303133;
  font-size: 13px;
  box-sizing: border-box;
}

.vdd-dialog .visit-overview {
  position: relative;
  padding: 16px 14px 14px;
  border-radius: 8px;
  background: #f5f9fc;
}

.vdd-dialog .visit-patient {
  display: flex;
  align-items: baseline;
  gap: 8px;

  strong {
    color: #1f2933;
    font-size: 16px;
    font-weight: 600;
  }

  span {
    color: #7c8793;
  }
}

.vdd-dialog .visit-status {
  position: absolute;
  top:  0px;
  right: 0px;
  border: 0;
  background: #FFF0E1;
  color: #FE8F1F;
  font-weight: 500;
  font-size: 13px;
}

.vdd-dialog .visit-meta {
  display: grid;
  grid-template-columns: 1fr 1fr 1.25fr;
  gap: 14px;
  margin-top: 12px;
  color: #303133;

  span {
    min-width: 0;
  }

  label {
    margin-right: 10px;
    color: #8b95a1;
  }
}

.vdd-dialog .visit-section {
  padding-top: 20px;
}

.vdd-dialog .visit-section-title {
  margin-bottom: 12px;
  color: #20252b;
  font-size: 14px;
  font-weight: 600;

  i {
    display: inline-block;
    width: 3px;
    height: 15px;
    margin-right: 7px;
    vertical-align: -2px;
    border-radius: 2px;
    background: #168cf0;
  }
}

.vdd-dialog .medical-record p,
.vdd-dialog .advice-record p {
  display: flex;
  margin: 0 0 8px;
  line-height: 20px;

  label {
    min-width: 60px;
    flex: 0 0 38px;
    color: #8b95a1;
  }

  span {
    white-space: pre-line;
    color: #303133;
  }
}

.vdd-dialog .vdd-case-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  white-space: normal;
}

.vdd-dialog .vdd-case-image {
  width: 48px;
  height: 48px;
  border-radius: 2px;
}

.vdd-dialog .prescription-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vdd-dialog .vdd-activity-card {
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  border: 1px solid #E0E0E0;
  border-radius: 4px;

  .vdd-activity-header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    padding: 0 12px;
  }

  .vdd-activity-header-left {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .vdd-activity-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .vdd-activity-title {
    margin-left: 10px;
    overflow: hidden;
    color: #000;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vdd-activity-description {
    margin-left: 10px;
    color: #667182;
    font-size: 13px;
    line-height: 20px;
    white-space: nowrap;
  }

  .vdd-activity-list {
    width: 100%;
  }

  .vdd-activity-project {
    width: 100%;
    border-top: 1px solid #E0E0E0;
  }

  .vdd-activity-project-header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
  }

  .vdd-activity-project-index {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    min-height: 40px;
    flex-shrink: 0;
    color: #000;
    font-size: 14px;
  }

  .vdd-activity-project-label {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    min-height: 40px;
    padding: 0 12px;
    border-left: 1px dashed #E0E0E0;
  }

  .vdd-activity-project-name {
    overflow: hidden;
    color: #000;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vdd-activity-project-type {
    flex-shrink: 0;
    margin-left: 4px;
    color: #667182;
    font-size: 14px;
    line-height: 20px;
  }

  .vdd-activity-project-count,
  .vdd-activity-project-remark {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: 40px;
    flex-shrink: 0;
    color: #667182;
    font-size: 14px;
    border-left: 1px dashed #E0E0E0;
  }

  .vdd-activity-project-count {
    width: 80px;
  }

  .vdd-activity-project-remark {
    width: 120px;
    padding: 0 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vdd-activity-point-section {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    padding: 8px 12px;
    border-top: 1px dashed #E0E0E0;
  }

  .vdd-activity-acupoint-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, 138px);
    gap: 8px;
    width: 100%;
  }

  .vdd-activity-acupoint-item {
    display: flex;
    box-sizing: border-box;
    width: 138px;
    height: 32px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .vdd-activity-acupoint-type {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 100%;
    flex-shrink: 0;
    color: #000;
    font-size: 14px;
    border-right: 1px solid #E0E0E0;
  }

  .vdd-activity-acupoint-name {
    min-width: 0;
    flex: 1;
    height: 30px;
    padding: 0 8px 0 4px;
    overflow: hidden;
    color: #000;
    font-size: 14px;
    line-height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vdd-activity-acupoint-total {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
    min-width: max-content;
    min-height: 32px;
    flex-shrink: 0;
    margin-left: 12px;
    padding-bottom: 8px;
    color: #29C01B;
    font-size: 14px;
    white-space: nowrap;
  }

  .vdd-activity-options {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: 100%;
    min-height: 49px;
    padding: 8px 12px;
    color: #000;
    font-size: 14px;
    border-top: 1px dashed #E0E0E0;
    gap: 0 12px;
  }

  .vdd-activity-option-item {
    min-height: 33px;
    color: #667182;
    line-height: 33px;
    white-space: nowrap;
  }

  .vdd-activity-option-tip {
    min-height: 33px;
    color: #000;
    line-height: 33px;
  }

  .vdd-activity-option-warning {
    display: flex;
    align-items: center;
    min-height: 33px;
    color: #FE8F1F;
    line-height: 33px;
  }

  .vdd-activity-remark {
    box-sizing: border-box;
    width: 100%;
    min-height: 48px;
    padding: 8px 12px;
    color: #1F2329;
    font-size: 14px;
    line-height: 32px;
    white-space: pre-wrap;
    border-top: 1px dashed #E0E0E0;
  }
}

.vdd-dialog .vdd-single-print-btn {
  flex: none;
  min-width: 56px;
  height: 28px;
  padding: 0 12px;
  border-color: #dcdfe6;
  color: #606266;
  background: #fff;
}

.vdd-dialog .physio-warp {
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
  margin-bottom: 0;
  border-radius: 0 0 4px 4px;
  background: #fff;

  .physio-top {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;
    border-bottom: 1px solid @borderColor;

    .top-left {
      display: flex;
      align-items: center;
      color: #333;
      font-size: 14px;
      min-width: 0;

      .physio-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        flex-grow: 0;
        margin-right: 10px;
      }

      .physio-title {
        color: #000;
        font-size: 14px;
        font-weight: 600;
        margin-right: 34px;
        white-space: nowrap;
      }
    }
  }

  .physio-content {
    .add-warp:last-child {
      .index {
        border-right: 0;
      }
    }

    .add-warp {
      border-top: 1px dashed @borderColor;

      &:first-child {
        border-top: 0;
      }

      >.index,
      .add-warp-item>.index {
        width: 32px;
        border-right: 1px dashed @borderColor;
        box-sizing: border-box;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        font-size: 14px;
        font-weight: 600;
      }

      >.select-warp,
      .add-warp-item>.select-warp {
        padding: 14px 0;
        width: 100%;
        min-width: 0;
        display: flex;
        align-items: center;
      }

      .readonly-select-warp {
        padding-left: 12px;
        padding-right: 12px;
        box-sizing: border-box;
      }

      .readonly-name {
        min-width: 0;
        overflow: hidden;
        color: #000;
        font-size: 14px;
        font-weight: 600;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      >.add-right,
      .add-warp-item>.add-right {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #1F2329;
        flex-shrink: 0;

        .unit-warp {
          height: 100%;
          color: #667182;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 20px;
          flex-grow: 0;
          flex-shrink: 0;
          white-space: nowrap;
        }

        .price-warp {
          height: 100%;
          color: #667182;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 20px;
          flex-grow: 0;
          flex-shrink: 0;
          border-left: 1px solid #E1E1E1;
          white-space: nowrap;
        }

        .edit-warp {
          width: 128px;
          border-left: 1px solid #E1E1E1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          color: #1F2329;
          white-space: nowrap;
          .readonly-remark {
            .el-input__inner{
              border-color: transparent !important;
              background-color: transparent !important;
              color: #1F2329 !important;
            }
          }
          .item-section {
            display: flex;
            align-items: center;
            color: #667182;
            font-size: 14px;
          }
        }
      }
    }

    >div>.add-warp {
      border-top: 1px solid @borderColor;
      border-bottom: 1px solid @borderColor;
      display: flex;
      height: 40px;

      &:last-child {
        border-bottom: 0;
      }
    }

    >.add-warp {
      border-top: 1px dashed @borderColor;

      &:first-child {
        border-top: 0;
      }
    }

    .add-warp-item {
      height: 40px;
      display: flex;
      border-bottom: 1px dashed @borderColor;

      &:last-child {
        border-bottom: 0;
      }
    }

    .add-warp-bottom {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 12px;

      .method-warp {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;

        .method-item {
          color: #1F2329;
          font-size: 14px;
          white-space: nowrap;
        }

        .singleDose-warp {
          display: flex;
          align-items: center;
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 14px;
          color: #1F2329;
          margin-left: 8px;
          white-space: nowrap;

          .singleDose-input {
            flex-grow: 0;
            flex-shrink: 0;
            min-width: 28px;
            max-width: 60px;
            height: 28px;
            line-height: 28px;
            margin: 0 4px;
            overflow: hidden;
            border-bottom: 1px solid @borderColor;
            text-align: center;
            color: #000;
          }
        }
      }
    }

    .acupoint-warp {
      width: 100%;
      display: flex;
      padding: 8px 12px;
      justify-content: space-between;
      box-sizing: border-box;

      .acupoint-list {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, 138px);
        gap: 8px;

        .acupoint-item {
          height: 32px;
          border-radius: 2px;
          border: 1px solid #E0E0E0;
          display: flex;
          background: #fff;
          position: relative;
          box-sizing: border-box;
          overflow: hidden;

          .acupoint-item-left {
            height: 100%;
            width: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            border-right: 1px solid #E0E0E0;
            color: #000;
            font-size: 14px;
          }

          .acupoint-item-name {
            min-width: 0;
            flex: 1;
            height: 30px;
            line-height: 30px;
            padding-left: 4px;
            padding-right: 8px;
            color: #000;
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .acupoint-total {
        color: #29C01B;
        font-size: 14px;
        padding-bottom: 8px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        flex-shrink: 0;
        flex-grow: 0;
        margin-left: 12px;
        white-space: nowrap;
      }
    }

    .other-warp {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px dashed #E1E1E1;
      padding: 8px 12px;

      .other-warp-left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: #000;
        font-size: 14px;

        .other-num-input {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #E0E0E0;
          flex-shrink: 0;
          flex-grow: 0;
          margin-right: 16px;
          min-height: 28px;

          .num-input {
            min-width: 60px;
            text-align: center;
          }

          .onlyNum-input {
            min-width: 20px;
            text-align: center;
          }
        }

        .frequency-input {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #E0E0E0;
          flex-shrink: 0;
          flex-grow: 0;
          margin-right: 16px;
          min-height: 28px;
        }

        .frequency-text {
          min-width: 70px;
          text-align: center;
        }

        .other-desc {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          flex-grow: 0;
          margin-right: 16px;
        }

        .other-tips {
          color: #FE8F1F;
          font-size: 14px;
          display: flex;
          align-items: center;
        }
      }

      .other-warp-right {
        color: #667182;
        font-size: 14px;
        flex-shrink: 0;
        margin-left: 12px;
        white-space: nowrap;
      }
    }
  }
}

.vdd-dialog .visit-physio-prescription {
  .physio-content {
    >div {
      border-bottom: 1px solid @borderColor;

      &:last-child {
        border-bottom: 0;
      }
    }

    >div>.add-warp {
      height: 40px;
      display: flex;
      border-top: 1px solid @borderColor;
      border-bottom: 1px solid @borderColor;
      box-sizing: border-box;

      >.index {
        border-right: 1px solid @borderColor !important;
      }

      >.select-warp {
        height: 100%;
        padding: 0 12px;
        border-right: 1px solid #E1E1E1;
        box-sizing: border-box;
      }

      >.add-right {
        height: 100%;

        .unit-warp,
        .price-warp,
        .edit-warp {
          height: 100%;
          box-sizing: border-box;
        }
      }
    }

    >div:first-child>.add-warp {
      border-top: 0;
    }

    .acupoint-warp {
      border-bottom: 1px dashed #E1E1E1;
    }

    .other-warp {
      min-height: 40px;
      box-sizing: border-box;
    }
  }
}

.vdd-dialog .visit-chinese-prescription {
  .physio-content {
    >.add-warp {
      >.add-warp-item>.index {
        border-right: 1px dashed @borderColor !important;
      }

      >.add-warp-item>.select-warp {
        padding: 0 12px;
        border-right: 1px solid #E1E1E1;
        box-sizing: border-box;
      }
    }
  }
}

.vdd-dialog .physio_remark_row {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.vdd-dialog .physio_remark_label {
  flex-shrink: 0;
  margin: 0 12px 0 0;
  line-height: 40px;
  font-size: 14px;
  color: #000000;
}

.vdd-dialog .physio_product_remark {
  width: 100%;
  flex-grow: 1;
  padding: 0;
  line-height: 40px;
  font-size: 14px;
  border: none;
  color: #1F2329;
  white-space: pre-wrap;
}

.vdd-dialog .vdd-other-prescription {
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
  margin-bottom: 0;
  border-radius: 0 0 4px 4px;
  background: #fff;

  .vdd-other-top {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    box-sizing: border-box;
    border-bottom: 1px solid @borderColor;
  }

  .vdd-other-title {
    color: #000;
    font-size: 14px;
    font-weight: 600;
  }

  .vdd-other-total {
    color: #667182;
    font-size: 14px;
    white-space: nowrap;
  }

  .vdd-other-row {
    border-top: 1px solid @borderColor;
    display: flex;
    height: 40px;
    box-sizing: border-box;

    &:first-child {
      border-top: 0;
    }

    .vdd-other-index {
      width: 32px;
      border-right: 1px solid @borderColor;
      box-sizing: border-box;
      flex-grow: 0;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 14px;
      font-weight: 600;
    }

    .vdd-other-select {
      padding: 0 12px;
      width: 100%;
      min-width: 0;
      display: flex;
      align-items: center;
      box-sizing: border-box;
    }

    .vdd-other-name {
      min-width: 0;
      overflow: hidden;
      color: #000;
      font-size: 14px;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .vdd-other-right {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      height: 100%;
      font-size: 14px;
      color: #1F2329;
    }

    .vdd-other-edit {
      width: 128px;
      border-left: 1px solid #E1E1E1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      white-space: nowrap;
    }

    .vdd-other-symbol,
    .vdd-other-unit {
      width: 30px;
      text-align: center;
    }

    .vdd-other-num {
      width: 50px;
      text-align: center;
    }

    .vdd-other-remark {
      width: 90px;
      overflow: hidden;
      color: #1F2329;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.vdd-dialog .drug-warp {
  border: 1px solid #e0e0e0;
  margin-bottom: 0;
  border-radius: 4px;
  background: #fff;

  .drug-top {
    height: 44px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
    justify-content: space-between;
    border-bottom: 1px solid #e0e0e0;
    box-sizing: border-box;

    .top-left {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666;
      min-width: 0;

      .drug-index {
        display: flex;
        align-items: center;

        .drug-icon {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          flex-shrink: 0;
        }
      }

      .drug-total {
        margin-left: 12px;
        font-size: 12px;
        color: #667182;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }
}

.vdd-dialog .drug-list {
  position: relative;
  z-index: 2;

  .drugItem:nth-of-type(4n) {
    .drug-search {
      border-right: 0;
    }
  }

  .drug-search {
    box-sizing: border-box;
    padding: 14px 10px 12px 10px;
    border-right: 1px dashed #e0e0e0;
    border-bottom: 1px dashed #e0e0e0;
    margin-bottom: -1px;
    position: relative;
    min-height: 56px;
  }

  .search-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .input-search {
    min-width: 0;
    overflow: hidden;
    color: #000;
    font-size: 14px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .read-only-dose-wrap {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #1f2329;
    font-size: 14px;
    font-weight: 600;
  }

  .input-dosage {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    white-space: nowrap;
  }

  .search-tips {
    font-size: 12px;
    color: #1f2329;
    margin-top: 2px;
  }
}

.vdd-dialog .drug-tips {
  font-size: 14px;
  color: #333;
  display: flex;
  padding: 0 18px;
  min-height: 40px;
  align-items: center;
  border-top: 1px dashed #e1e1e1;
  justify-content: space-between;
  gap: 12px;

  .drug-tips-left {
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 18px;
  }

  .drug-tip-text {
    white-space: nowrap;
  }

  .drug-tips-right {
    flex: none;
    color: #7c8793;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
  }
}

.vdd-dialog .visit-empty {
  padding: 14px;
  color: #a4afba;
  text-align: center;
  border: 1px dashed #dfe3e8;
  border-radius: 4px;
}

.vdd-dialog .visit-advice-section {
  padding-bottom: 4px;
}

.vdd-dialog .vdd-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px 16px;
  border-top: 1px solid #ebeef5;
  box-sizing: border-box;

  .vdd-footer-left {
    flex: none;
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .vdd-invoice-status {
    display: inline-flex;
    align-items: center;
    color: #1f2329;
    font-size: 14px;
    white-space: nowrap;
    cursor: pointer;
  }

  .issue {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 36px;
    .issue-label {
      color: #667182;
    }

    .issue-value {
      position: relative;
      cursor: pointer;
      height: 42px;
      line-height: 42px;

      .issue-value-text {
        margin-right: 4px;

        &.green {
          color: #29C01B;
        }
      }

      .el-icon-caret-bottom {
        color: #A4AFBA;
      }

      &:hover {
        .option {
          display: block;
        }
      }

      .option {
        display: none;
        position: absolute;
        bottom: calc(100% + 8px);
        left: 0;
        right: auto;
        z-index: 20;
        width: 320px;
        max-width: calc(100vw - 80px);
        padding: 6px 12px;
        background: #FFFDE9;
        border-radius: 4px;
        font-size: 13px;
        box-sizing: border-box;
        filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.15));

        &:before {
          content: '';
          position: absolute;
          bottom: -6px;
          left: 26px;
          right: auto;
          z-index: 2;
          width: 10px;
          height: 10px;
          border: 1px solid transparent;
          background-color: #FFFDE9;
          transform: rotate(-45deg);
        }

        .option-item {
          padding: 6px 0;
          line-height: 14px;
          color: #667182;
          text-align: left;
          .option-item-title {
            color: #000000;
          }

          .option-item-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            margin-top: 10px;

            .option-item-content-orderNum {
              margin-right: 12px;
              flex: 1;
              min-width: 0;
              word-break: break-all;
            }

            .option-item-content-status {
              flex: none;
              white-space: nowrap;
              color: #000000;
              &.green {
                color: #29C01B;
              }

              &.gray {
                color: #667182;
              }
            }
          }
        }
      }

    }
  }

  .vdd-footer-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.vdd-dialog .vdd-footer /deep/ .el-button {
  min-width: 86px;
}

.vdd-dialog .vdd-footer /deep/ .el-button+.el-button {
  margin-left: 0;
}

.vdd-dialog .ml5 {
  margin-left: 5px;
}

.vdd-dialog .mr6 {
  margin-right: 6px;
}

.vdd-dialog .w100_ {
  width: 100%;
  text-align: center;
}

.vdd-dialog .flex-sh {
  flex-shrink: 0;
}

.vdd-dialog .colorFE8F {
  color: #FE8F1F;
}

@media (max-width: 700px) {
  .vdd-dialog .visit-meta {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .vdd-dialog .drug-list {
    .el-col {
      width: 50%;
    }
  }

  .vdd-dialog .physio-warp {
    .physio-top .top-left .physio-title {
      margin-right: 12px;
    }

    .physio-content {

      .add-warp,
      .add-warp-item {
        min-width: 680px;
      }

      .acupoint-warp,
      .other-warp {
        min-width: 680px;
      }
    }
  }
}
</style>
